<template>
    <b-container class="py-5" v-if="form.mode">
        <template v-if="form.mode.startsWith('pending')">
            <b-alert show variant="warning" class="pt-4">
                <strong>現在、受付していません</strong>
                <ul class="pl-4">
                    <li>このフォームは準備中です。</li>
                </ul>
            </b-alert>
        </template>

        <template v-else>
            <div>
                <FormAnswerSteps
                    :model="answer"
                    :options="form.meta.text.steps"
                    />
            </div>

            <template>
                <template v-if="form.mode.startsWith('closed')">
                    <b-alert show variant="warning" class="pt-4">
                        <strong>現在、受付していません</strong>
                        <ul class="pl-4">
                            <li>このフォームの申込を締め切りました。</li>
                        </ul>
                    </b-alert>
                </template>

                <template v-if="form.mode.startsWith('activated.limits')">
                    <template v-if="[ 'canceled', 'completed', ].indexOf(answer.status) === -1">
                        <b-alert show variant="danger" class="pt-4">
                            <strong>現在、受付していません</strong>
                            <ul class="pl-4">
                                <li v-if="form.mode === 'activated.limits.opened_at'">受付開始は{{ form.limits_opened_at | baseDatetimeFormatter }}です。</li>
                                <li v-if="form.mode === 'activated.limits.closed_at'">受付締切は{{ form.limits_closed_at | baseDatetimeFormatter }}です。</li>
                                <li v-if="form.mode === 'activated.limits.maximum'">受付人数が上限を超えました。</li>
                            </ul>
                        </b-alert>
                    </template>
                </template>

                    <b-alert show variant="danger" v-if="validateErrors.length" class="pt-4">
                        <strong>入力に誤りがあります</strong>
                        <ul class="pl-4">
                            <li v-for="item in validateErrors">{{ item }}</li>
                        </ul>
                    </b-alert>

                <template v-if="form.mode === 'activated.open.edit'">
                    <template v-if="[ 'canceled', 'completed', ].indexOf(answer.status) === -1">
                        <b-alert show variant="warning" v-if="form.limits_closed_at || form.limits_maximum" class="pt-4">
                            <strong>受付締切について</strong>
                            <ul class="pl-4">
                                <li v-if="form.limits_closed_at">受付締切は{{ form.limits_closed_at | baseDatetimeFormatter }}です。</li>
                                <li v-if="form.limits_maximum">受付人数は最大{{ form.limits_maximum }}名（現在{{ 0 }}名）です。</li>
                            </ul>
                        </b-alert>
                    </template>
                </template>

                <b-alert show variant="success" v-if="[ 'completed', ].indexOf(answer.status) >= 0 && form.description_completed" class="pt-4">
                    <div v-html="form.description_completed">
                    </div>
                </b-alert>

                <template v-if="form.mode === 'activated.open.edit' || form.is_owner">
                    <template v-if="[ 'sent', ].indexOf(answer.status) >= 0">
                        <b-card class="mb-5">
                            <div class="mb-5 text-center">
                                <h1 class="mt-4"><strong>&yen;{{ answer.payment_price | baseNumberFormatter }}-</strong></h1>

                                <template v-if="!form.payment_is_refundable">
                                    <span class="text-danger">ご返金はできませんのでご注意ください。</span><br>
                                </template>
                            </div>

                            <template v-if="form.payment_provider">
                                <div class="my-4">
                                    <h5 class="mb-3"><strong>クレジット決済を希望される方</strong></h5>
                                    <p>『クレジット決済』ボタンを押してください。</p>
                                    <b-button block variant="primary" class="mt-3" @click="payWith('payjp')">クレジット決済</b-button>
                                </div>
                            </template>

                            <p>&emsp;</p>

                            <template v-if="form.payment_bank_account">
                                <div class="my-4">
                                    <h5 class="mb-3"><strong>口座振込を希望される方</strong></h5>
                                    <p>下記の口座に振り込んで下さい。</p>
                                    <pre class="form-payment-bank-account">{{ form.payment_bank_account }}</pre>
                                    <p>振込メッセージに受付番号『<span class="text-danger">{{ answer.meta.text.number }}</span>』を設定してください。スムーズな入金確認のため、ご協力お願いします。</p>
                                    <p>再度、この画面を表示するには、自動送信メールに記載されたリンクにアクセスをしてください。</p>
                                    <p>振込が終わりましたら、『振込完了をお知らせ』ボタンを押してください。</p>
                                    <b-button block variant="primary" class="mt-3" @click="payWith('BANK')">振込完了をお知らせ</b-button>
                                </div>
                            </template>
                        </b-card>
                    </template>
                </template>

                <h3 class="form-name">{{ form.name }}</h3>

                <template v-if="form.mode === 'activated.open.sent'">
                    <b-alert show variant="success" class="pt-4">
                        <strong v-if="answer_uuid">本登録が完了しました</strong>
                        <strong v-if="!answer_uuid">仮登録を行いました</strong>
                        <ul class="pl-4">
                            <li>
                                メールを確認してください。ご登録頂いたメールアドレス宛に確認メールを送信しました。
                                <span v-if="answer_uuid">届いたメールの内容を確認してください。</span>
                                <span v-if="!answer_uuid">届いたメールに従って本登録を完了させてください。</span>
                            </li>
                        </ul>
                        <strong>数時間経過してもメールが届かない場合</strong>
                        <ul class="pl-4">
                            <li>確認メールが迷惑メールに振り分けられてしまっている場合があります。ご確認ください。</li>
                            <li v-if="!answer_uuid">それでも確認できない場合、登録されたメールアドレスを間違えている可能性があります。再度、仮登録を行ってください。（<a :href="`/f/${user_uuid}/${form_uuid}`">仮登録&gt;&gt;</a>）</li>
                            <li v-if="!answer_uuid">@icloud.com／@me.com／@mac.com等のメールアドレスは迷惑メール判定のフィルターが厳しく、メールが届かないという事象も確認しております。そのため、該当メールアドレスをご使用されている場合は大変申し訳ございませんが、@gmail.com等の別のメールアドレスのご利用をご検討くださいますよう、よろしくお願い申し上げます。 再度、仮登録を行ってください。（<a :href="`/f/${user_uuid}/${form_uuid}`">仮登録&gt;&gt;</a>）</li>
                        </ul>
                    </b-alert>
                </template>

                <template v-else>
                    <div class="mb-5" v-html="form.description">
                    </div>
                </template>
            </template>

<!--
            <template v-if="form.mode === 'activated.open.edit'">
-->
            <template v-if="form.mode === 'activated.open.edit' || answer.uuid || form.is_owner">
                <form method="post" @submit.prevent="submit">
                    <input
                        type="hidden"
                        name="answer_uuid"
                        :value="answer_uuid" />
    
                    <template v-if="!answer.uuid && form.mode !== 'activated.open.sent'">
                        <b-form-group>
                            <strong>メールアドレス</strong>
                            <b-form-input
                                type="email"
                                name="email"
                                />
                            <span class="text-muted">@icloud.com／@me.com／@mac.com等のメールアドレスは迷惑メール判定のフィルターが厳しく、メールが届かないという事象も確認しております。そのため、該当メールアドレスをご使用されている場合は大変申し訳ございませんが、@gmail.com等の別のメールアドレスのご利用をご検討くださいますよう、よろしくお願い申し上げます。</span>
                        </b-form-group>
    
                        <b-form-group>
                            <strong>メールアドレス確認用</strong><br>
                            <span>念のため、もう一度入力してください</span>
                            <b-form-input
                                type="email"
                                name="email_confirmation"
                                />
                        </b-form-group>

                        <b-form-group>
                            <strong>名前</strong><br>
                            <span>姓名の間にスペースなし</span>
                            <b-form-input
                                name="name"
                                placeholder="山田太郎"
                                />
                        </b-form-group>
    
                        <p class="my-5">
                            <b-button block variant="primary" type="submit">仮登録する</b-button>
                        </p>
                    </template>
    
                    <template v-if="answer.uuid">
                        <b-form-group>
                            <strong>メールアドレス</strong>
                            <b-form-input
                                name="email"
                                readonly
                                />
                        </b-form-group>

                        <b-form-group>
                            <strong>名前</strong>
                            <b-form-input
                                name="name"
                                readonly
                                />
                        </b-form-group>

                        <fieldset
                            :disabled="answer.status !== 'pending'"
                            >
                            <BaseEditor
                                v-model="form.fields"
                                :editable="false"
                                />
                        </fieldset>

                        <template>
                            <template v-if="[ 'pending', ].indexOf(answer.status) >= 0">
                                <b-button block variant="primary" type="submit">送信する</b-button>
                            </template>

                            <template v-if="[ 'pending', 'sent', 'paid', 'completed', ].indexOf(answer.status) >= 0">
                                <hr>
                                <b-button block variant="danger" class="mb-3" @click="cancel">取消する</b-button>
                                <span class="text-danger">
                                    <span>取消した手続きは復元することができません。</span><br>
                                    <template v-if="[ 'paid', 'completed', ].indexOf(answer.status) >= 0">
                                        <template v-if="!form.payment_is_refundable">
                                            <span>ご返金はできませんのでご注意ください。</span><br>
                                        </template>
                                    </template>
                                </span>
                            </template>

                            <template v-if="[ 'completed', ].indexOf(answer.status) >= 0 && form.is_owner">
                                <hr>
                                <b-button block variant="primary" class="mb-3" @click.prevent="editAsOwner">運営として編集する</b-button>
                                <span>編集をやめたい場合、画面を再読込してください。</span><br>
                            </template>
                        </template>
                    </template>
                </form>

            </template>

            <p class="py-5"></p>

            <FormAnswerSteps
                :model="answer"
                :options="form.meta.text.steps"
                class="mt-5"
                />

<!--
            <template v-if="answer_uuid && answer.uuid">
                <hr class="py-5">
                <b-card header="全ての手続きの状況">
                    同じメールアドレスで登録した手続きです。<br>
                    確認するにはリンクにアクセスしてください。<br>
                    <template v-for="item in answer.all_answers">
                        <a :href="`/f/${user_uuid}/${form_uuid}/${item.uuid}/${email_hashed}`" target="_blank">
                            #{{ ('' + item.id).padStart(8, '0') }}
                            {{ item.name }}
                            [{{
                            trans.labels[
                            'form_answers.status.' + item.status
                            ]
                            }}]
                        </a>
                        <br>
                    </template>
                    <br>

                    追加申し込みをする場合、再度、仮登録を行ってください。（<a :href="`/f/${user_uuid}/${form_uuid}`">仮登録&gt;&gt;</a>）
                </b-card>
            </template>
-->
        </template>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import FormAnswerSteps from '@/components/FormAnswerSteps.vue'

export default {
    components: {
        FormAnswerSteps,
    },
    props: {
        user_uuid: {
            type: String,
            required: true,
        },
        form_uuid: {
            type: String,
            required: true,
        },
        answer_uuid: {
            type: String,
            required: false,
        },
        email_hashed: {
            type: String,
            required: false,
        },
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'trans',
            'csrf_token',
        ]),
    },
    data() {
        return {
            form: {},
            answer: {},
            validateErrors: [],
            mode: null,
        }
    },
    watch: {
        $route: {
            async handler () {
                this.fetchForm()
            },
            immediate: true
        }
    },
    mounted() {
        window.setTimeout(() => {
            this.scrollTop()
        }, 500)
    },
    methods: {
        async fetchForm (with_answer = true) {
            const response = await this.$store.dispatch('form/show', this.form_uuid)
            if (this.isResponseError(response)) {
                return false
            }
            this.form = Object.assign({}, this.form, response.data)

            if (with_answer && this.answer_uuid) {
                this.fetchAnswer()
            }

            setTimeout(this.updateOptionLabels, 2000)
        },
        async fetchAnswer () {
            const response = await this.$store.dispatch('answer/show', { form_uuid: this.form_uuid, answer_uuid: this.answer_uuid, email_hashed: this.email_hashed, })
            if (this.isResponseError(response)) {
                return false
            }
            this.setAnswer(response.data)
        },
        async setAnswer (data) {
            this.answer = Object.assign({}, this.answer, data)
            setTimeout(this.restoreAnswerPayload, 1000)
        },
        async restoreAnswerPayload () {
            document.querySelectorAll('form [name]').forEach((e) => {
                const answer_value = this.answer.fields[e.name.replace(/\[\]$/, '')]
                switch (e.tagName) {
                    case 'TEXTAREA':
                        e.value = answer_value || null
                        break
                    case 'INPUT':
                        if (e.type === 'checkbox') {
                            if (Array.isArray(answer_value)) {
                                e.checked = answer_value.indexOf(e.value) >= 0
                            } else {
                                e.checked = e.value === answer_value
                            }
                        } else if (e.type === 'radio') {
                            e.checked = e.value === answer_value
                        } else {
                            e.value = answer_value || null
                        }
                        break
                    case 'SELECT':
                        Array.prototype.forEach.call(e.options, (option) => {
                            if (Array.isArray(answer_value)) {
                                option.selected = answer_value.indexOf(option.value) >= 0
                            } else {
                                option.selected = option.value === answer_value
                            }
                        })
                        break
                }
            })
        },
        buildAnswerPayload () {
            let fields = {};
            document.querySelectorAll('form [name]').forEach((e) => {
                const name = e.name.replace(/\[\]$/, '')
                switch (e.tagName) {
                    case 'TEXTAREA':
                        fields[name] = e.value || null
                        break
                    case 'INPUT':
                        if (e.type === 'checkbox') {
                            if (e.checked && e.value !== null && e.value !== '') {
                                if (!Array.isArray(fields[name])) {
                                    fields[name] = []
                                }
                                fields[name].push(e.value)
                            }
                        } else if (e.type === 'radio') {
                            if (e.checked) {
                                fields[name] = e.value || null
                            }
                        } else {
                            fields[name] = e.value || null
                        }
                        break
                    case 'SELECT':
                        Array.prototype.forEach.call(e.options, (option) => {
                            if (option.selected && option.value !== null && option.value !== '') {
                                if (!Array.isArray(fields[name])) {
                                    fields[name] = []
                                }
                                fields[name].push(option.value)
                            }
                        })
                        break
                }
            })
            return fields
        },
        async submit (event) {
            this.scrollTop()

            this.validateErrors = []
            let formObject = this.buildAnswerPayload()
            formObject.form_uuid = this.form.uuid
            formObject.answer_uuid = this.answer.uuid
            formObject.email_hashed = this.email_hashed
            formObject.updated_at = this.answer.updated_at
            const response = await this.$store.dispatch('answer/save', formObject)
            if (this.isResponseError(response)) {
                if (response.data.errors) {
                    let fields = [];
                    let validateErrors = [];
                    document.querySelectorAll('form [name]').forEach((e) => {
                        fields.push(e.name.replace(/\[\]$/, ''))
                    })
                    fields = [...new Set(fields)]
                    fields.forEach((name) => {
                        if (response.data.errors[name]) {
                            response.data.errors[name].forEach((e) => {
                                validateErrors.push(e)
                            })
                        }
                    })
                    this.validateErrors = validateErrors
                }

                this.fetchForm(false)

                return false
            }

            if (this.answer.uuid) {
                this.setAnswer(response.data)
                this.fetchForm(false)
            } else {
                this.form.mode = 'activated.open.sent'
            }
        },
        async cancel (event) {
            if (!confirm(this.trans.messages['info.click-to-cancel-item'])) {
                return
            }

            this.scrollTop()

            this.validateErrors = []
            const response = await this.$store.dispatch('answer/cancel', {
                form_uuid: this.form.uuid,
                answer_uuid: this.answer.uuid,
                email_hashed: this.email_hashed,
                updated_at: this.answer.updated_at,
            })
            if (this.isResponseError(response)) {
                this.fetchForm(false)
                return false
            }

            this.setAnswer(response.data)
            this.fetchForm(false)
        },
        async payWith (provider) {
            location.href = `/payment/${provider}/${encodeURIComponent(this.form.uuid)}/${encodeURIComponent(this.answer.uuid)}/${encodeURIComponent(this.email_hashed)}`
        },
        editAsOwner ($event) {
            this.answer.status = 'pending'
        },
        updateOptionLabels () {
            document.querySelectorAll('form [name]').forEach((e) => {
                const name = e.name.replace(/\[\]$/, '')
                switch (e.tagName) {
                    case 'INPUT':
                        if ([ 'checkbox', 'radio', ].indexOf(e.type) >= 0) {
                            const node = document.querySelector('label[for="'+e.id+'"] span');
                            const option = this.form.field_nodes[name].options.filter((option) => { return option.value === e.value })
                            if (option.length) {
                                node.innerText = option[0].text
                            }
                        }
                        break
                    case 'SELECT':
                        Array.prototype.forEach.call(e.options, (node) => {
                            const option = this.form.field_nodes[name].options.filter((option) => { return option.value === node.value })
                            if (option.length) {
                                node.innerText = option[0].text
                            }
                        })
                        break
                }
            })
        },
        scrollTop: function(){
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
        },
    },
}
</script>

